export default "__VITE_ASSET__fd76d314__"